import { Routes } from '@angular/router';

export const brandActivityMappingsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/admin/brand-activity-mapping/overview/overview.component').then(component => component.OverviewComponent),
  },
  {
    path: 'add',
    loadComponent: () => import('@app/admin/brand-activity-mapping/add/add.component').then(component => component.AddComponent),
  },
  {
    path: ':id',
    loadComponent: () => import('@app/admin/brand-activity-mapping/details/details.component').then(component => component.DetailsComponent),
  },
  {
    path: ':id/edit',
    loadComponent: () => import('@app/admin/brand-activity-mapping/edit/edit.component').then(component => component.EditComponent),
  },
];
